import React from 'react'

// Replaces `next/image` in the widget build with a plain <img>. Next's image optimizer needs
// the Next server, which the casino doesn't run. width/height/style/className/onError all pass
// straight through; Next-only props are dropped.
type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string | { src: string }
  fill?: boolean
  priority?: boolean
  quality?: number
  placeholder?: string
  blurDataURL?: string
  unoptimized?: boolean
  loader?: unknown
}

export default function Image({
  src,
  alt,
  fill,
  priority,
  quality,
  placeholder,
  blurDataURL,
  unoptimized,
  loader,
  ...rest
}: ImageProps) {
  void fill
  void priority
  void quality
  void placeholder
  void blurDataURL
  void unoptimized
  void loader
  const resolved = typeof src === 'string' ? src : src?.src ?? ''
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={resolved} alt={alt ?? ''} {...rest} />
}
